import request from '@/axios'
import type { RequestConfig } from '@/axios/types'

export const login = (data: object) => {
  return request.post({ url: '/account/login', data })
}

export const usoGetUserInfo = () => {
  const url = import.meta.env.VITE_APP_USP_API + '/usp-auth/account/getInfo'
  return request.post({
    url,
    data: {
      serverCode: 'bi'
    }
  })
}

export const uspLogin = (data: any) => {
  const url = import.meta.env.VITE_APP_USP_API + '/usp-auth/account/login'
  return request.post({
    url,
    data: { ...data, fromServerCode: 'bi', fromChannelCode: 'webLogin', toServerCode: 'bi' }
  })
}

export const getUniqueId = (data: object) => {
  return request.post({ url: '/account/generateUniqueId', data })
}

export const uspGetUniqueId = (
  data: object,
  options?: {
    isForgetPwd?: boolean
  }
) => {
  const url = import.meta.env.VITE_APP_USP_API + '/usp-auth/verifyCode/generateUniqueId'
  return request.post({
    url,
    data: {
      ...data,
      channelCode: options?.isForgetPwd ? 'resetPwdLogin' : 'webLogin',
      serverCode: 'bi'
    }
  })
}

export const sendLoginSms = (
  data: object,
  options?: {
    transformResponse?: RequestConfig['transformResponse']
    isForgetPwd?: boolean
  }
) => {
  const url = import.meta.env.VITE_APP_USP_API + '/usp-auth/verifyCode/sendSms'
  const { transformResponse, isForgetPwd } = options || {}
  return request.post({
    url,
    // url: isForgetPwd ? '/account/sendForgetPwdSms' : '/account/sendLoginSms',
    data: {
      ...data,
      channelCode: isForgetPwd ? 'resetPwdLogin' : 'webLogin',
      serverCode: 'bi',
      type: 'phoneSms'
    },
    transformResponse
  })
}

export const uspForgetPwdLoginRequest = (data: object) => {
  const url = import.meta.env.VITE_APP_USP_API + '/usp-auth/account/resetPwdLogin'
  return request.post({
    url,
    data: { ...data, fromServerCode: 'bi', fromChannelCode: 'resetPwdLogin', toServerCode: 'bi' }
  })
}

export const forgetPwdLoginRequest = (data: object) => {
  return request.post({ url: '/account/forgetPwd', data })
}

export const uspLogoutRequest = () => {
  const url = import.meta.env.VITE_APP_USP_API + '/usp-auth/account/logout'
  return request.post({
    url,
    data: { fromServerCode: 'bi', fromChannelCode: 'webLogout', toServerCode: 'bi' }
  })
}

export const logoutRequest = () => {
  return request.post({ url: '/account/logout' })
}

export const getResetPwd = () => {
  return request.post({ url: '/account/getResetPwd' })
}

export const uspUpdatePwd = (data: object) => {
  const url = import.meta.env.VITE_APP_USP_API + '/usp-auth/account/pwdUpdate'
  return request.post({ url, data: { ...data, serverCode: 'bi' } })
}
